import { render, staticRenderFns } from "./Header.layout.vue?vue&type=template&id=83d63942&scoped=true&"
import script from "./Header.layout.vue?vue&type=script&lang=js&"
export * from "./Header.layout.vue?vue&type=script&lang=js&"
import style0 from "./Header.layout.vue?vue&type=style&index=0&id=83d63942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d63942",
  null
  
)

export default component.exports